import { render, staticRenderFns } from "./updateDocumentImage.vue?vue&type=template&id=3a88fea4&"
import script from "./updateDocumentImage.vue?vue&type=script&lang=ts&"
export * from "./updateDocumentImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports